import React, { Suspense } from "react";
import { Route, Routes } from "react-router";
import Error from "../components/common/Error";
import PublicLayout from "../layout/PublicLayout";
import About from "../pages/About";
import Contact from "../pages/Contact";
import Home from "../pages/Home";

const PageRoute = () => {
  return (
    <Routes>
      <Route>
        <Route element={<PublicLayout />}>
          <Route
            exact
            path="/"
            element={
              <Suspense fallback={"loading"}>
                <Home />
              </Suspense>
            }
          />
          <Route
            exact
            path="/home"
            element={
              <Suspense fallback={"loading"}>
                <Home />
              </Suspense>
            }
          />
          <Route
            exact
            path="/about"
            element={
              <Suspense fallback={"loading"}>
                <About />
              </Suspense>
            }
          />
          <Route
            exact
            path="/contact-us"
            element={
              <Suspense fallback={"Loading"}>
                <Contact />
              </Suspense>
            }
          />
        </Route>
        <Route
          path="*"
          element={
            <Suspense fallback={"loading"}>
              <Error />
            </Suspense>
          }
        ></Route>
      </Route>
    </Routes>
  );
};

export default PageRoute;
